export function handleStickyNavCollapse(): void {
	const stickyPlaceholder = document.getElementById('sticky-placeholder') as HTMLElement;
	const mainContent = document.getElementById('main') as HTMLElement;
	if (stickyPlaceholder && mainContent) {
		const observer = new MutationObserver(() => {
			if (stickyPlaceholder.style.display === 'none') {
				mainContent.style.paddingTop = '';
			} else {
				mainContent.style.paddingTop = '92px';
			}
		});
		observer.observe(stickyPlaceholder, { attributes: true, attributeFilter: ['style'] });
	}
}